export default{
	computed:{
	    $oc() {
	      return this.$tquery.getApi("oc");
	    },
	},
	methods:{
        //获取注册进展
	    async getRegistProgress() {
		    return await this.$oc.get(`/my/registerProgress`).then(res=>{
			    if(res.status=="200"){
			    	return res.data
			    }
		    })
	            
	    }
	}
}
